import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import NotFound from "@/pages/store/NotFound";

/** Catch-all: ask the redirect manager before 404ing; log the 404 either way. */
export function LegacyFacetRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    navigate(location.pathname.replace(/^\/f\//, "/jewellery/"), { replace: true });
  }, [location.pathname, navigate]);
  return <div className="container-x py-20 text-center text-stone-400 font-mono text-sm">REDIRECTING…</div>;
}

export default function RedirectGate() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | notfound

  useEffect(() => {
    const path = location.pathname;
    setState("checking");
    api.get("/redirects/resolve", { params: { path } })
      .then((r) => navigate(r.data.to, { replace: true }))
      .catch(() => {
        setState("notfound");
        api.post("/seo/log-404", { path, referrer: document.referrer || "" }).catch(() => {});
      });
  }, [location.pathname, navigate]);

  if (state === "checking") {
    return <div className="container-x py-20 text-center text-stone-400 font-mono text-sm">LOADING…</div>;
  }
  return <NotFound />;
}

/** Shopify legacy shapes that map 1:1 — immediate client redirect, no API call. */
export function LegacyProductRedirect() {
  return <ImmediateRedirect build={(p) => `/products/${p.pid}`} />;
}

function ImmediateRedirect({ build }) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const parts = location.pathname.split("/").filter(Boolean);
    const pid = parts[parts.length - 1];
    navigate(build({ pid }), { replace: true });
  }, [location.pathname, navigate, build]);
  return <div className="container-x py-20 text-center text-stone-400 font-mono text-sm">REDIRECTING…</div>;
}
